module.exports = __webpack_public_path__ + "b9df0070c538eeb1cadc683284e1885d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201509_Presse_AVANGA_WAZ_4MB.jpg
// module id = 562
// module chunks = 0